module.exports = __webpack_public_path__ + "media/images/C9hqhcPCdQ7CqfWJRo3i-1b2c6d08a9bdd069296a2bf782d3aed5.png";